import { HttpClient, parseJSONApiResponse } from '@opallabs/api'
import loadContentPiece from '../loadContentPiece'

const fetchContent = (contentId) =>
  HttpClient().get(`/api/v1/content/${contentId}`)

const getContentPiece = (contentId) => (dispatch) =>
  fetchContent(contentId)
    .then((response) =>
      dispatch(loadContentPiece(parseJSONApiResponse(response.data)))
    )
    .catch((err) => {
      console.log(err)
      throw err
    })

export default getContentPiece
